import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import PdfViewer from "../../components/PdfViewer";

const getPdfUrl = locale =>
  ({
    [locale]:
      "https://buscar.terras.app/app/files/buscar-manual-usuario-web_12-04-2021.pdf",
    'en-US': 'https://buscar.terras.app/app/files/buscar-manual-usuario-web_12-04-2021.pdf'
  }[locale]);

const Manual = () => {
  const { locale } = useIntl();
  const [pdfUrl, setPdfUrl] = useState(getPdfUrl(locale));

  useEffect(() => {
    setPdfUrl(getPdfUrl(locale));
  }, [locale]);

  return (
    <>
      <h1>Manual</h1>

      <div className="content-box manual">
        <PdfViewer url={pdfUrl} title="Manual" />
      </div>
    </>
  );
};

export default Manual;
